<template>
  <div class="all">
    <ul class="list">
      <li class="list-item" v-for="(item,index) in list" :key="index" @click="jumpTo(index)">
        <van-image class="image" :src="item.img"></van-image>
        <div class="text">{{ item.text }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {

  },
  components: {

  },
  data () {
    return {
      // tab栏图片
      list: [
        {
          img: require('@/assets/images/home/icon_01.png'),
          text: '粤教培训',
          link: { name: 'Book', active: 0 }
        },
        // {
        //   img: require('@/assets/images/home/icon_02.png'),
        //   text: '优秀课例',
        //   link: { name: 'Book', active: 1 }
        // },
        {
          img: require('@/assets/images/home/icon_03.png'),
          text: '教学资源',
          link: { name: 'Book', active: 2 }
        },
        {
          img: require('@/assets/images/home/icon_04.png'),
          text: '协同教研',
          // link: 'Radio'
          link: 'Research'
        },
        {
          img: require('@/assets/images/home/icon_05.png'),
          text: '专家问答',
          link: 'Issue'
        },
        {
          img: require('@/assets/images/home/icon_06.png'),
          text: '热门活动',
          link: 'Search'
        },
        {
          img: require('@/assets/images/home/icon_07.png'),
          text: '资讯',
          link: 'Infomation'
        },
        {
          img: require('@/assets/images/home/icon_08.png'),
          text: '书架',
          link: { name: 'Book', active: 3 }
        },
        {
          img: require('@/assets/images/home/icon_09.png'),
          text: '教学研究',
          link: 'Study'
        },
        {
          img: require('@/assets/images/home/icon_10.png'),
          text: '我的备课',
          link: 'MyClass'
        },
        {
          img: require('@/assets/images/home/icon_info_07.png'),
          text: '学前教育',
          link: 'Preschool'
        },
        {
          img: require('@/assets/images/home/icon_info_05.png'),
          text: '课后服务',
          link: 'AfterSchool'
        }
      ]
    };
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {

    /* Tab栏跳转 */
    jumpTo (index) {
      const { $router, list } = this;
      let name = list[index].link;

      /* 判断 如果是对象 则跳转到学习页面 否则正常进行跳转 */
      if (name instanceof Object) {
        let obj = name;
        $router.push({
          name: obj.name,
          query: {
            active: obj.active
          }
        });
      } else {
        $router.push({
          name: name
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
  .all{
    padding: 40px 28px;
    .list{
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      .list-item{
        width: 25%;
        margin-top: 40px;
        &:nth-child(-n+4){
          margin-top: 0;
        }
        .image{
          width: 88px;
          height: 80px;
          display: inline-block;
          vertical-align: middle;
        }
        .text{
          font-size: 24px;
          line-height: 34px;
          color: #333444;
        }
      }
    }
  }
</style>
